import React from 'react';
import { EditPage } from '@components/common';
import RefillForm from '@components/common/forms/RefillForm';

const RefillEditPage = () => {
    return (
        <EditPage
            modelName="refills"
            FormComponent={RefillForm}
        />
    );
};

export default RefillEditPage;
